<ng-container class="v2">
    <h1 class="rewards-title" aria-label="Get Your Reward">Get Your Reward</h1>
    <div class="notice">
        <div>See what you’ve used your Points on. It may take up to 48 hours to process new activity.</div>
    </div>

    <div *ngIf="!error && showLoading" class="loading-div-tiny" id="fp-loading" aria-live="polite" aria-busy="true" role="alert" tabindex="2">
        <div class="loading-spinner">
            <div alt="Loading..." class="large progress" aria-label="Loading...">
                <div class="prog1">
                    <div class="prog2"></div>
                </div>
            </div>
        </div>
    </div>

    <div *ngIf="!error && !showLoading && (!rewardsSecondary || rewardsSecondary.length <= 0)" class="get-your-rewards-no-rewards-container">
        <div class="get-your-rewards-no-rewards-logo-container">
            <img aria-hidden="true" class="get-your-rewards-icon" role="img" src="{{appHostURL}}/etc/designs/wcax-commons/images/icons/GroceryBag.svg" alt="Grocery Bag logo"/>
        </div>
    
        <div class="get-your-rewards-no-rewards-body">
            <h2 class="get-your-rewards-no-rewards-heading-size">No rewards redeemed</h2>
            <p class="get-your-rewards-no-rewards-description-text">When you use Points for grocery rewards you'll
                see them here.</p>
        </div>
        <div class="get-your-rewards-no-rewards-footer">
            <button class="btn btn-xl btn-primary body-text get-your-rewards-no-rewards-footer__button" type="button"
                (click)="openRewardsPage()" (keypress)="openRewardsPage()" aria-label="Got it, redirect to rewards page">
                Got it!
            </button>
        </div>   
    </div>
</ng-container>
<ng-container *ngIf="!error" >
    <div class="point-reward-grid-container">
        <div class="reward-grid">
            <ng-container *ngIf="!showLoading">
                <ng-container *ngFor="let reward of rewardsSecondary">
                    <point-reward-card [ngClass]="rewardCardDisabled ? 'reward-grid-itme' : 'reward-card-container'"
                                       [reward]="reward" [appHostURL]="appHostURL" [userInfo]="userInfo"
                                       [currentEnvironment]="currentEnvironment" [enableCashReward]="enableCashReward"
                                       [isPointScoreCardFlow]="pointScoreCardFlow"
                                       (callMyListApi)="triggerMyListAPI($event)"
                                       [isGetYourRewardFlow] ="isGetYourRewardFlow"
                                       [rewardsResponseObj]="rewardsResponseObj"></point-reward-card>
                </ng-container>
            </ng-container>


        </div>
    </div>
</ng-container>


<ng-container *ngIf="error && !showLoading">
    <div>
        <div class="get-your-rewards-no-rewards-container">
            <div class="get-your-rewards-no-rewards-logo-container">
                <img aria-hidden="true" class="get-your-rewards-icon" src="/ocrp-rewards-ui/dist/assets/images/icon/page-load-error.svg" alt="Page Load error logo" />
            </div>

            <div class="get-your-rewards-no-rewards-body">
                <h2 class="get-your-rewards-no-rewards-heading-size">Page couldn’t load</h2>
                <p class="get-your-rewards-no-rewards-description-text">We’re sorry, this page failed to load. Please refresh this page or contact customer service.</p>
            </div>
            <div class="get-your-rewards-no-rewards-footer">
                <button type="button" class="btn btn-xl btn-primary body-text get-your-rewards-no-rewards-footer__button" (click)="reLoadPage()" (keypress)="reLoadPage()" aria-label="Retry">
                    Retry
                </button>
            </div>
        </div>
    </div>
</ng-container>

